/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Speaker insertion form" |
*
* @param {Insert_Speaker_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_form_label = /** @type {((inputs?: Insert_Speaker_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire d'insertion de locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprechereinführungsformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di inserimento dell'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма для добавления докладчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de inserción de oradores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发言人录入表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー挿入フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर सम्मिलन प्रपत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de inserção de alto-falante")
	return /** @type {LocalizedString} */ ("Speaker insertion form")
});